import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import useSessionStore from '@/stores/useSessionStore'
import { brand } from '@/utils/brand'
import { getV5ApiUrl } from '@/utils/urlHelpers'

const useDeletePaymentMethodApi = (): UseMutationResult<null, Error, string> => {
  const authToken = useSessionStore((state) => state.authToken)
  const queryClient = useQueryClient()

  const mutationFn = useCallback(
    async (id: string): Promise<null> => {
      const url = getV5ApiUrl(`/users/me/payments/methods/braintree/${id}`)

      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'x-brand-id': brand.key,
          'x-user-token': authToken,
        } as HeadersInit,
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.errors || `Failed to delete payment method: ${response.status}`)
      }

      return null
    },
    [authToken],
  )

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['payment-methods', brand.key] }),
  })
}

export default useDeletePaymentMethodApi
